import { createContext } from 'react';

const AppDispatchContext = createContext(null);

export default AppDispatchContext;
